<div
  class="rounded-2xl border-l-8 border-blue-primary bg-gray-5 p-5 shadow-lg"
  [ngClass]="selected() ? 'border-blue-primary' : 'border-gray-2'"
>
  <div class="flex items-center justify-between">
    <div class="flex w-10/12 flex-col gap-2">
      <div class="flex">
        <span class="w-3/12 text-gray-2">
          {{ "appointments.labels.doctorName" | translate }}
        </span>
        <span class="w-8/12">{{ suggestionData().doctorName }}</span>
      </div>

      <div class="flex">
        <span class="w-3/12 text-gray-2">
          {{ "appointments.labels.address" | translate }}
        </span>
        <span class="w-8/12">{{ suggestionData().locationName }}</span>
      </div>

      <div class="flex">
        <span class="w-3/12 text-gray-2">
          {{ "appointments.labels.time" | translate }}
        </span>
        <span class="w-8/12">
          {{ formatDate(suggestionData().startDate, true) }}
          - {{ suggestionData().endDate | date: "HH:mm" }}
        </span>
      </div>
    </div>

    <div class="flex w-2/12 items-center justify-end">
      @if (!selected()) {
        <button
          class="btn btn-primary text-sm"
          (click)="selectSuggestion()"
        >
          {{ "buttons.select" | translate }}
        </button>
      } @else {
        <button
          class="flex items-center justify-center rounded-full bg-blue-primary p-2 text-gray-5"
          (click)="selectSuggestion()"
        >
          <mat-icon [fontIcon]="'done'"></mat-icon>
        </button>
      }
    </div>
  </div>
</div>
